// Indian mobile numbers are stored as +91 followed by 10 digits.
export function formatIndianMobile(value) {
  let cleaned = (value || '').replace(/[^\d+]/g, '');
  if (!cleaned.startsWith('+')) {
    if (cleaned.startsWith('91') && cleaned.length > 10) cleaned = '+' + cleaned;
    else if (cleaned.length > 0) cleaned = '+91' + cleaned;
  }
  return cleaned.slice(0, 13);
}

export const isValidIndianMobile = (n) => /^\+91\d{10}$/.test(n || '');
